import React from "react";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { CONTACT_EMAIL } from "@/config/site";

const REWARD_LINE = "Refer a company to us. If they sign, you get 10% of the full project value.";

const STEPS = [
  { step: "01", desc: "Send us the introduction. A name and a warm connection is enough to start." },
  { step: "02", desc: "We run the conversation and close the deal." },
  { step: "03", desc: "Once they have paid in full, you receive 10% of the full project value within 14 days." },
];

export default function ReferralPage() {
  return (
    <main data-testid="referral-page">
      <Seo
        title="Referral Program"
        description="Refer a company to Raki Solutions in Singapore and earn 10% of the full project value once they sign and pay."
        path="/referral"
      />
      <PageHero
        label="Referral Program"
        headline="Know a company that is losing leads?"
        subline={REWARD_LINE}
      />

      <section className="px-6 sm:px-8 pb-20 sm:pb-28" data-testid="referral-steps">
        <div className="max-w-4xl mx-auto">
          <h2 className="font-fraunces font-extrabold text-3xl sm:text-4xl tracking-tight text-[#1F1F1C]">How it works</h2>
          <div className="mt-10 grid sm:grid-cols-3 gap-5">
            {STEPS.map((s) => (
              <div
                key={s.step}
                className="card-lift bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/10 p-7"
                data-testid={`referral-step-${s.step}`}
              >
                <span className="font-fraunces font-extrabold text-sm text-[#C8703A]">{s.step}</span>
                <p className="mt-4 text-sm text-[#4A463F] leading-relaxed">{s.desc}</p>
              </div>
            ))}
          </div>

          <div className="mt-14 bg-[#EADCC6] rounded-2xl border border-[#1F1F1C]/10 p-8 sm:p-10">
            <h2 className="font-fraunces font-extrabold text-2xl sm:text-3xl tracking-tight text-[#1F1F1C]">
              Ready to make an introduction?
            </h2>
            <p className="mt-4 text-sm md:text-base text-[#4A463F] leading-relaxed max-w-xl">
              Send us the company name and a warm intro. We handle the rest.
            </p>
            <div className="mt-8">
              <a
                href={`mailto:${CONTACT_EMAIL}?subject=Referral`}
                className="btn-press inline-flex items-center justify-center gap-2 rounded-2xl bg-[#C8703A] text-[#F4E9D8] px-7 py-4 font-semibold text-sm sm:text-base hover:bg-[#B35F2C]"
                data-testid="referral-cta"
              >
                Refer a company <ArrowRight className="w-4 h-4" strokeWidth={2.25} />
              </a>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
